import { Sunrise, Sun, Moon, Gem, TramFront, MapPin } from "lucide-react";
import { T } from "@/i18n";

const SLOTS = [
  { key: "morning", label: "Mattina", icon: Sunrise },
  { key: "afternoon", label: "Pomeriggio", icon: Sun },
  { key: "evening", label: "Sera", icon: Moon },
];

const Day = ({ d }) => (
  <div data-testid={`itinerary-day-${d.day}`} className="print-break relative grid gap-6 border-t border-gray-100 py-10 md:grid-cols-[180px_1fr]">
    <div>
      <p className="font-display text-5xl font-extrabold text-emerald-100">{String(d.day).padStart(2, "0")}</p>
      <p className="mt-1 text-xs font-semibold uppercase tracking-widest text-emerald-700"><T n={d.day}>{"Giorno {n}"}</T></p>
      {d.area && <p className="mt-2 flex items-center gap-1 text-sm text-gray-500"><MapPin className="h-3.5 w-3.5" />{d.area}</p>}
    </div>
    <div>
      <h4 className="font-display text-xl font-semibold text-gray-900">{d.title}</h4>
      <div className="mt-5 grid gap-4 lg:grid-cols-3">
        {SLOTS.map(({ key, label, icon: Icon }) => (
          <div key={key} className="rounded-2xl bg-slate-50 p-5 transition-colors hover:bg-emerald-50/70">
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-gray-500"><Icon className="h-4 w-4 text-emerald-600" /><T>{label}</T></p>
            <p className="mt-3 text-sm leading-relaxed text-gray-700">{d[key]}</p>
          </div>
        ))}
      </div>
      <div className="mt-4 flex flex-col gap-3 text-sm sm:flex-row">
        {d.local_gem && <p className="flex flex-1 gap-2 text-gray-600"><Gem className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" /><span><strong className="text-gray-900"><T>Gemma locale:</T></strong> {d.local_gem}</span></p>}
        {d.transport_tip && <p className="flex flex-1 gap-2 text-gray-600"><TramFront className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" /><span><strong className="text-gray-900"><T>Spostamenti:</T></strong> {d.transport_tip}</span></p>}
      </div>
    </div>
  </div>
);

export const Itinerary = ({ days = [] }) => (
  <div data-testid="itinerary-timeline" className="rounded-3xl border border-emerald-100 bg-white px-8 pt-8 md:px-10">
    <p className="text-xs font-semibold uppercase tracking-widest text-emerald-700"><T>Itinerario giorno per giorno</T></p>
    <h3 className="mt-2 font-display text-2xl font-semibold text-gray-900"><T>Un ritmo bilanciato, senza corse.</T></h3>
    <div className="mt-6">{days.map((d) => <Day key={d.day} d={d} />)}</div>
  </div>
);
